export default __webpack_public_path__ + "static/media/define-entities-for-the-system.d715894b.svg";